var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showEmptyError)?_c('div',{staticClass:"empty-error text text-red"},[_vm._v(" "+_vm._s(_vm.$t('empty_error'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }